'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import MuiGlobalStyles from '@mui/material/GlobalStyles';
import { getFontFaceStyles } from './getFontFaceStyles';
import { getTokens } from './getTokens';
export const themeAttributeMap = {
    jdGreen: 'jd-green',
    jdBlack: 'jd-black'
};
export const GlobalStyles = (props) => (_jsx(MuiGlobalStyles, { styles: (theme) => `
            ${!props.excludeFontStyles ? getFontFaceStyles() : ''}

            :root {
                ${getTokens(theme)}
            }
        ` }));
